// extracted by mini-css-extract-plugin
export default {"text":"flightsRouteSidebar-module__text__vrMCe","timeText":"flightsRouteSidebar-module__timeText__QET9v","dateAndLuggage":"flightsRouteSidebar-module__dateAndLuggage__6TOg1"};